// Portfolio and Strategy package IDs from migration
export const PORTFOLIO_PACKAGE_ID = "7c4e2f8a-9b3d-4e67-8f2a-1c5b9e8d7a6f";
export const STRATEGY_PACKAGE_ID = "a8f5c2d9-6e4b-4a19-9d8f-3e7c1b5a9d2e";